import styles from "./InputPanel.module.scss";

type IInputPanel = {
  children: React.ReactNode;
};

export const InputPanel = ({ children }: IInputPanel) => {
  return <div className={styles.inputPanel}>{children}</div>;
};
